import React from "react";
import style from "./style.module.css";
import PNNL from "../../images/pnnl.png"
import HCII from "../../images/hcii.svg"

export function Sponsors() {
    return (
        <section className={style.sponsors}>
            <section className={style.images}>
                <img className={style.logo} src={PNNL} alt="Pacific Northwest National Laboratory Logo"/>
                <img className={style.logo} src={HCII} alt="Human-Computer Interaction Institute Logo" />
            </section>
            <p className={style.blurb}>
                We partnered with Pacific Northwest National Laboratory (PNNL) to explore how we can employ Artificial Intelligence (AI) to curb the problem of misinformation.
            </p>
        </section>
    );
}